export {default} from './Details.connect';
